/* Kyvell BF · free gifts in the cart (2026-10-27; list of gifts 2026-10-29; minimum per gift 2026-10-29).
   Rule: each gift (window.KyvellBfGift.gifts = [{id, min}]) is in the cart exactly once, qty 1, while the qualifying
   product (window.KyvellBfGift.handle) has at least that gift's `min` units; below it, that gift is removed.
   Today: eBook from 2 books, stickers from 3 books.
   How: wraps window.fetch and only looks at /cart/add, /cart/change and /cart/update responses. If the cart needs a
   correction, it does it ONCE (with the same `sections` the theme asked for) and hands the theme a response whose
   `sections` already show the corrected cart, so the drawer renders once, without flicker. Corrections use the original
   fetch, so they never trigger themselves (no request loops). Any error = the theme gets its original response untouched.
   Config (Theme settings > BF free gift (cart)) is printed by snippets/bf-cart-gift.liquid. Off = this file is not loaded. */
(function () {
  var C = window.KyvellBfGift;
  if (C && !C.variants && C.variant) C.variants = [C.variant];
  if (C && C.variants && !(C.gifts && C.gifts.length)) C.gifts = C.variants.map(function (v) { return { id: v, min: C.min }; });
  if (!C || !C.variants || !C.variants.length || !C.handle || window.__kyvellBfGiftOn || !window.fetch) return;
  window.__kyvellBfGiftOn = true;

  var _fetch = window.fetch.bind(window);
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var RX = /\/cart\/(add|change|update)(\.js)?\/?$/;
  var chain = Promise.resolve();

  function run(fn) { var r = chain.then(fn, fn); chain = r.catch(function () {}); return r; }

  function pathOf(input) {
    try { return new URL(typeof input === 'string' ? input : (input && input.url) || '', location.href).pathname; }
    catch (e) { return ''; }
  }

  function readSections(body) {
    var s = null, u = null;
    try {
      if (!body) return null;
      if (typeof body.get === 'function') { s = body.get('sections'); u = body.get('sections_url'); }
      else if (typeof body === 'string') {
        try { var j = JSON.parse(body); s = j.sections; u = j.sections_url; }
        catch (e) { var p = new URLSearchParams(body); s = p.get('sections'); u = p.get('sections_url'); }
      }
    } catch (e) {}
    if (!s) return null;
    if (typeof s === 'string') s = s.split(',');
    return { sections: s, sections_url: u || location.pathname };
  }

  function isCart(d) { return !!d && Array.isArray(d.items) && typeof d.item_count === 'number'; }

  function touches(d) {
    var list = Array.isArray(d && d.items) ? d.items : [d];
    return list.some(function (i) { return i && (i.handle === C.handle || C.variants.indexOf(i.variant_id) > -1); });
  }

  function json(r) { if (!r.ok) throw new Error('bf-gift ' + r.status); return r.json(); }
  function getCart() { return _fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(json); }
  function post(url, payload) {
    return _fetch(ROOT + url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(json);
  }

  /* What the cart needs: null = nothing. {upd:{key:qty}|null, add:[{id,quantity:1}]|null} */
  function plan(cart) {
    var q = 0, upd = {}, n = 0, add = [];
    cart.items.forEach(function (i) { if (i.handle === C.handle) q += i.quantity; });
    C.gifts.forEach(function (g) {
      var v = g.id, lines = cart.items.filter(function (i) { return i.variant_id === v; });
      if (q >= (g.min || C.min)) {
        if (!lines.length) add.push({ id: v, quantity: 1 });
        lines.forEach(function (l, k) { var t = k === 0 ? 1 : 0; if (l.quantity !== t) { upd[l.key] = t; n++; } });
      } else {
        lines.forEach(function (l) { upd[l.key] = 0; n++; });
      }
    });
    return (n || add.length) ? { upd: n ? upd : null, add: add.length ? add : null } : null;
  }

  /* Applies the plan; the LAST request carries the sections. Returns {cart|null, sections|null}. */
  function apply(p, sec) {
    var extra = sec ? { sections: sec.sections, sections_url: sec.sections_url } : {};
    var out = { cart: null, sections: null };
    var step = Promise.resolve();
    if (p.upd) step = step.then(function () {
      return post('cart/update.js', Object.assign({ updates: p.upd }, p.add ? {} : extra)).then(function (d) {
        out.cart = d; if (d.sections) out.sections = d.sections;
      });
    });
    if (p.add) step = step.then(function () {
      return post('cart/add.js', Object.assign({ items: p.add }, extra)).then(function (d) {
        out.cart = null; if (d.sections) out.sections = d.sections;
      });
    });
    return step.then(function () { return out; });
  }

  function respond(res, obj) {
    return new Response(JSON.stringify(obj), {
      status: res.status, statusText: res.statusText,
      headers: { 'Content-Type': 'application/json; charset=utf-8' }
    });
  }

  /* Slow path (fallback): the theme's request goes out as is, then the cart is corrected once. */
  function legacy(input, init, path) {
    var p = _fetch(input, init);
    var sec = readSections(init && init.body);
    return p.then(function (res) {
      if (!res.ok) return res;
      return res.clone().json().then(function (data) {
        var cartShaped = isCart(data);
        if (!cartShaped && !(/\/cart\/add/.test(path) && touches(data))) return res;
        return run(function () {
          return (cartShaped ? Promise.resolve(data) : getCart()).then(function (cart) {
            var pl = plan(cart);
            if (!pl) return res;
            return apply(pl, sec).then(function (fx) {
              var sections = fx.sections || data.sections;
              if (!cartShaped) return respond(res, Object.assign({}, data, sections ? { sections: sections } : {}));
              return (fx.cart ? Promise.resolve(fx.cart) : getCart()).then(function (c) {
                var merged = Object.assign({}, data, c);
                if (sections) merged.sections = sections; else delete merged.sections;
                return respond(res, merged);
              });
            });
          });
        });
      }).catch(function () { return res; });
    });
  }

  /* Fast path (2026-10-30): the gift change travels IN THE SAME request as the theme's change, so the drawer is
     rendered once, by Shopify, with the final cart. +/- in the drawer or on /cart = 1 GET cart.js + 1 POST update.js. */
  function bodyObj(body) {
    if (!body) return null;
    try {
      if (typeof body.forEach === 'function' && typeof body.get === 'function') {
        var o = {}; body.forEach(function (v, k) { o[k] = v; }); return o;
      }
      if (typeof body === 'string') {
        try { return JSON.parse(body); }
        catch (e) { var r = {}; new URLSearchParams(body).forEach(function (v, k) { r[k] = v; }); return r; }
      }
    } catch (e) {}
    return null;
  }
  function isBook(v) { return C.book && C.book.indexOf(Number(v)) > -1; }
  /* Simulated cart: [{key, v, h, q}] */
  function lines(cart) { return cart.items.map(function (i) { return { key: i.key, v: i.variant_id, h: i.handle, q: i.quantity }; }); }
  function planLines(ls) {
    var q = 0, upd = {}, n = 0, add = [];
    ls.forEach(function (l) { if (l.h === C.handle || isBook(l.v)) q += l.q; });
    C.gifts.forEach(function (g) {
      var mine = ls.filter(function (l) { return l.v === g.id && l.key && l.q > 0; });
      if (q >= (g.min || C.min)) {
        if (!mine.length) add.push(g.id);
        mine.forEach(function (l, k) { var t = k === 0 ? 1 : 0; if (l.q !== t) { upd[l.key] = t; n++; } });
      } else mine.forEach(function (l) { upd[l.key] = 0; n++; });
    });
    return (n || add.length) ? { upd: upd, add: add } : null;
  }
  function postUpdate(updates, sec) {
    var payload = { updates: updates };
    if (sec) { payload.sections = sec.sections; payload.sections_url = sec.sections_url; }
    return _fetch(ROOT + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    });
  }
  /* /cart/change and /cart/update: returns {ls, intent} or null (= unknown shape → slow path). */
  function simulate(kind, cart, b) {
    var ls = lines(cart), intent = {};
    function find(id) {
      id = String(id);
      for (var k = 0; k < ls.length; k++) if (ls[k].key === id || (id.indexOf(':') < 0 && String(ls[k].v) === id)) return k;
      return -1;
    }
    if (kind === 'change') {
      if (b.properties || b.selling_plan) return null;
      var q = parseInt(b.quantity, 10), idx = -1;
      if (isNaN(q) || q < 0) return null;
      if (b.line != null && b.line !== '') idx = parseInt(b.line, 10) - 1;
      else if (b.id != null) idx = find(b.id);
      if (!(idx >= 0 && idx < ls.length)) return null;
      ls[idx].q = q; intent[ls[idx].key] = q;
      return { ls: ls, intent: intent };
    }
    var u = b.updates;
    if (!u) {
      Object.keys(b).forEach(function (k) { var m = /^updates\[(.+)\]$/.exec(k); if (m) { u = u || {}; u[m[1]] = b[k]; } });
      if (!u) return null;
    }
    if (Array.isArray(u)) {
      if (u.length !== ls.length) return null;
      for (var a = 0; a < u.length; a++) { var qa = parseInt(u[a], 10); if (isNaN(qa) || qa < 0) return null; ls[a].q = qa; intent[ls[a].key] = qa; }
      return { ls: ls, intent: intent };
    }
    var keys = Object.keys(u);
    for (var j = 0; j < keys.length; j++) {
      var i2 = find(keys[j]), qj = parseInt(u[keys[j]], 10);
      if (i2 < 0 || isNaN(qj) || qj < 0) return null;
      ls[i2].q = qj; intent[ls[i2].key] = qj;
    }
    return { ls: ls, intent: intent };
  }
  function fastChange(kind, input, init, path) {
    var b = bodyObj(init && init.body);
    if (!b) return legacy(input, init, path);
    return run(function () {
      return getCart().then(function (cart) {
        var sim = simulate(kind, cart, b);
        if (!sim) return null;
        var pl = planLines(sim.ls);
        if (!pl) return _fetch(input, init); /* no gift change: the theme's own request, untouched */
        var updates = Object.assign({}, sim.intent, pl.upd);
        pl.add.forEach(function (v) { updates[v] = 1; });
        return postUpdate(updates, readSections(init && init.body)).then(function (res) { return res.ok ? res : null; });
      });
    }).then(function (res) { return res || legacy(input, init, path); }, function () { return legacy(input, init, path); });
  }
  /* /cart/add of the book: the gift fix goes FIRST (no sections, fast), then the theme's add renders the final cart. */
  function fastAdd(input, init, path) {
    var b = bodyObj(init && init.body), items = null;
    if (b) {
      if (Array.isArray(b.items)) items = b.items;
      else if (b.id != null) items = [{ id: b.id, quantity: b.quantity }];
    }
    var plus = 0;
    (items || []).forEach(function (it) { if (isBook(it.id)) { var n = parseInt(it.quantity == null || it.quantity === '' ? 1 : it.quantity, 10); plus += isNaN(n) ? 1 : n; } });
    if (!plus) return legacy(input, init, path);
    return run(function () {
      return getCart().then(function (cart) {
        var ls = lines(cart);
        ls.push({ key: null, v: C.book[0], h: C.handle, q: plus });
        var pl = planLines(ls);
        if (!pl) return null;
        var updates = Object.assign({}, pl.upd);
        pl.add.forEach(function (v) { updates[v] = 1; });
        return postUpdate(updates, null).then(function () { return null; });
      });
    }).catch(function () {}).then(function () { return legacy(input, init, path); });
  }

  window.fetch = function (input, init) {
    var path = pathOf(input), m = RX.exec(path);
    if (!m) return _fetch(input, init);
    try {
      if (m[1] === 'add') return fastAdd(input, init, path);
      return fastChange(m[1], input, init, path);
    } catch (e) { return legacy(input, init, path); }
  };

  /* Page load: the server already knows if the cart breaks the rule (C.fix). Only then: fix once and refresh. */
  function swap(sections, cart) {
    function inner(html, sel) {
      var el = new DOMParser().parseFromString(html, 'text/html').querySelector(sel);
      return el ? el.innerHTML : null;
    }
    var d = document.getElementById('CartDrawer'), b = document.getElementById('cart-icon-bubble'), h;
    if (sections['cart-drawer'] && d && (h = inner(sections['cart-drawer'], '#CartDrawer')) !== null) d.innerHTML = h;
    if (sections['cart-icon-bubble'] && b && (h = inner(sections['cart-icon-bubble'], '.shopify-section')) !== null) b.innerHTML = h;
    var drawer = document.querySelector('cart-drawer');
    if (drawer && cart) drawer.classList.toggle('is-empty', cart.item_count === 0);
  }

  function onLoad() {
    if (!C.fix) return;
    var KEY = 'kyvell-bf-gift-fix', now = Date.now(), last = 0;
    try { last = +(sessionStorage.getItem(KEY) || 0); sessionStorage.setItem(KEY, String(now)); } catch (e) {}
    if (now - last < 15000) return; /* never loops */
    var hasDrawer = !!document.getElementById('CartDrawer');
    var sec = (!C.cartPage && hasDrawer) ? { sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: location.pathname } : null;
    run(function () {
      return getCart().then(function (cart) {
        var pl = plan(cart);
        if (!pl) return;
        return apply(pl, sec).then(function (fx) {
          if (C.cartPage) { location.reload(); return; }
          if (fx.sections) return (fx.cart ? Promise.resolve(fx.cart) : getCart()).then(function (c) { swap(fx.sections, c); });
        });
      });
    }).catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onLoad);
  else onLoad();
})();
